export default class StripeProduct {
  public id: string;
  public active: string;
  public name: string;
  public productType: string;
  public description: string;

  constructor(options) {
    this.id = options.id;
    this.active = options.active;
    this.name = options.name;
    this.productType = options.productType;
    this.description = options.description;
  }
}
